export const validEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export const formErrorToSpanish = {
  'Auth.form.error.invalid': 'Usuario o contraseña inválidos',
  'Auth.form.error.confirmed': 'Revisa tu email para confirmar tu cuenta',
}